module.exports = __webpack_public_path__ + "527e94ab319017f7e21fbc2d09a6d3e1.png";